import {
  Box,
  Paper,
  Tab,
  Tabs,
  Stack,
  Typography,
  Chip,
} from "@mui/material";
import React from "react";
import FolderOpenRoundedIcon from "@mui/icons-material/FolderOpenRounded";
import { useParams } from "react-router-dom";

import TabPanelFormat from "../../../../components/widgets/TabPanelFormat";
import { getHashdata } from "./utils";
import { setHash } from "../../../../components/Tabs/Utils/hashFunctions";
import { pvTabs } from "./PVTabs";
import { PVContext } from "./PV.Context";
import LoadProjectDataComboBox from "./LoadProjectDataComboBox";

function ProjectSelectionHeader({
  plantId,
  clientName,
  type,
  selectedProject,
  onProjectSelect,
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        mb: 1.5,
        px: 1.5,
        py: 1,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        bgcolor: "background.paper",
      }}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={1.5}
        alignItems={{ xs: "stretch", md: "center" }}
      >
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{ minWidth: 210 }}
        >
          <FolderOpenRoundedIcon
            fontSize="small"
          />

          <Typography
            variant="body2"
            fontWeight={700}
            sx={{  whiteSpace: "nowrap" }}
          >
            Load Project Data
          </Typography>
        </Stack>

        <Box sx={{ width: "100%", maxWidth: 360 }}>
          <LoadProjectDataComboBox
            plantId={plantId}
            clientName={clientName}
            type={type}
            label="Select Project"
            onSelect={onProjectSelect}
          />
        </Box>

        {selectedProject && (
          <Chip
            size="small"
            color="success"
            variant="outlined"
            label={selectedProject?.name || selectedProject?.link || "Selected"}
            sx={{
              maxWidth: 220,
              fontWeight: 600,
              "& .MuiChip-label": {
                overflow: "hidden",
                textOverflow: "ellipsis",
              },
            }}
          />
        )}
      </Stack>
    </Paper>
  );
}

export default function PVMain() {
  const { project, currentTab, setCurrentTab } = React.useContext(PVContext);

  const [selectedProject, setSelectedProject] = React.useState(null);

  const { plantId } = useParams();

  const tabs = pvTabs(project);

  const navLabel = "pv-modeling";

  const clientName = "DEMO";
  const type = "pv";

  React.useEffect(() => {
    if (!tabs.length) return;

    const fullHash = window.location.hash;
    const hashValue = getHashdata(fullHash, navLabel);

    const tabIndex = tabs.findIndex(
      (tab) => tab.label === decodeURIComponent(hashValue),
    );

    if (tabIndex !== -1) {
      setCurrentTab(tabIndex);
    } else if (fullHash) {
      window.location.hash =
        fullHash + "&" + navLabel + "=" + encodeURIComponent(tabs[0].label);
    } else {
      window.location.hash =
        navLabel + "=" + encodeURIComponent(tabs[0].label);
    }
  }, []);

  const handleChange = (event, newValue) => {
    setCurrentTab(newValue);
    setHash(window.location.hash, navLabel, tabs[newValue].label);
  };

  const handleProjectSelect = (selectedProjectData) => {
    console.log("selected PV project", selectedProjectData);
    setSelectedProject(selectedProjectData);

    // If you have a setter inside PVContext, call it here.
    // Example:
    // setProject(selectedProjectData);
    // setModelingData(selectedProjectData?.data);
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        p: 0,
      }}
    >
      <ProjectSelectionHeader
        plantId={plantId}
        clientName={clientName}
        type={type}
        selectedProject={selectedProject}
        onProjectSelect={handleProjectSelect}
      />

      <Paper
        sx={{
          width: "100%",
          display: "flex",
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 2,
          overflow: "hidden",
        }}
      >
        <Box sx={{ width: "100%", overflow: "auto" }}>
          <Tabs
            value={currentTab}
            onChange={handleChange}
            orientation="horizontal"
            variant="scrollable"
            scrollButtons="auto"
          >
            {tabs.map((tab, i) => (
              <Tab key={tab.label} label={tab.label} value={i} />
            ))}
          </Tabs>

          {tabs[currentTab] && (
            <TabPanelFormat padding={0} {...tabs[currentTab].panelProps}>
              {tabs[currentTab].panel}
            </TabPanelFormat>
          )}
        </Box>
      </Paper>
    </Box>
  );
}